// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__I7iF9","buttonContent":"Controls_buttonContent__1AXoO"};